import React from "react"
import TickerDropDown from "./tickerdropdown"
import ExpirySelector from "./expiryselector"
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {OptionType} from "../data/options"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {logEvent} from "../analytics";
/*
    ChainPicker allows for selecting an option chain {ticker, expiry}
        The user can select a ticker and expiry and this control will bubble them up to its container
*/
export default class ChainPicker extends React.Component {
    state = {
        selected_ticker: "KSS",
        selected_expiry: "",
        selected_option_type:OptionType.Call, 
    }

    /* respond to the user changing any of the inputs */
    /*
    tickerChanged = newTicker => { this.setState({selected_ticker:newTicker},()=>{this.notifyOfChainChange()}); }
    expiryChanged = newExpiry => { this.setState({selected_expiry:newExpiry},()=>{this.notifyOfChainChange()}); }
    optionTypeChanged = event => { this.setState({selected_option_type:event.target.value},()=>{this.notifyOfChainChange()}); }
    */
   
    handleTextInput = (field,value) => this.setState({[field]:value},()=>this.notifyOfChainChange());
        

    /* pass the new chain up to the container */
    notifyOfChainChange = () => {
        const chain = {
            ticker: this.state.selected_ticker,
            expiry: this.state.selected_expiry,
            option_type: this.state.selected_option_type
        };

        this.props.onChainChanged(chain);
        logEvent("chainChanged", chain);
    }

    componentDidMount = () => this.setState({selected_ticker:this.props.defaultTicker},()=>this.notifyOfChainChange());
    
    render() {
        return (
        <Table>
        <TableBody>
          <TableRow>
            <TableCell>
                <TickerDropDown OptionsOnly={true} defaultTicker={this.props.defaultTicker}  onSelectedTickerChanged={(t)=>this.handleTextInput('selected_ticker',t)} helperText="Select underlying company"/>
            </TableCell>
            <TableCell>
                <ExpirySelector ticker={this.state.selected_ticker} id="optionExpirySelector" onSelectedExpiryChange={(ex)=>this.handleTextInput('selected_expiry',ex)} />
            </TableCell>
            <TableCell>
                <RadioGroup 
                    value={parseInt(this.state.selected_option_type)} 
                    onChange={(e)=>this.handleTextInput('selected_option_type',e.target.value)} 
                    name="optionTypeSelector" 
                    id="optionTypeSelector">
                          <FormControlLabel value={OptionType.Call} control={<Radio/>} label="Call"/>
                          <FormControlLabel value={OptionType.Put}  control={<Radio/>} label="Put" />
                </RadioGroup>   
            </TableCell>
          </TableRow>
      </TableBody>
    </Table>     
        ) 
    }
}